<template>
  <div :class="getSizeClass()" :style="{ borderColor: getTheme.fore }" ref="fig">
    <div @click="toggle('fire')">
      <NovenaryFigureLine :figure-id="this.figureId" :is-active="isLineActive('fire')" :is-editable="isEditable" />
    </div>
    <div @click="toggle('air')">
      <NovenaryFigureLine :figure-id="this.figureId" :is-active="isLineActive('air')" :is-editable="isEditable" />
    </div>
    <div @click="toggle('water')">
      <NovenaryFigureLine :figure-id="this.figureId" :is-active="isLineActive('water')" :is-editable="isEditable" />
    </div>
    <div @click="toggle('earth')">
      <NovenaryFigureLine :figure-id="this.figureId" :is-active="isLineActive('earth')" :is-editable="isEditable" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Anime from "animejs";
import NovenaryFigureLine from "./NovenaryFigureLine";

export default {
  name: "NovenaryFigure",
  components: {
    NovenaryFigureLine
  },
  props: {
    figureId: Number,
    isEditable: Boolean
  },
  mounted() {
    if (this.figureId >= 1 && this.figureId <= 3) {
      const timeline = Anime.timeline();

      timeline.add({
        targets: this.$refs.fig,
        opacity: 0,
        duration: 300,
        easing: "easeInQuad",
        delay: 800 + this.figureId * 100
      });

      timeline.add({
        targets: this.$refs.fig,
        opacity: 1,
        duration: 300,
        easing: "easeOutQuad"
      });
    }
  },
  computed: {
    ...mapGetters(["getTheme"])
  },
  methods: {
    toggle(elem) {
      if (this.isEditable) {
        this.$store.commit({
          type: "toggleNovenaryFigureElem",
          id: this.figureId,
          elem
        });
      }
    },
    isLineActive(elem) {
      return this.$store.getters.getNovenaryFigureById(this.figureId)[elem];
    },
    getSizeClass() {
      return {
        figure: true
      };
    }
  }
};
</script>

<style scoped lang="scss">
$border-width: 1px;
$border-style: solid;

.figure {
  text-align: center;
  box-sizing: border-box;
  cursor: default;
  position: relative;
  height: 6.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
